import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { getRandomInt } from '../helpers'
import artistList from '../data/popular.artist.json'

import Segment from './SegmentFull'

const artists = artistList.music;

class AS extends React.Component {
  state = {
    search: '',
    params: [],
    showMenu: false,
  }

  timer = null;

  handleChange = (ev) => {
    const name = ev.target.name;
    const value = ev.target.value;

    // const replace = ['who likes'];
    // const re = new RegExp(replace.join('|'),'gi');
    // console.log(value.replace(re, ''));

    this.setState({
      [name]: value,
      params: value.split(',')
    })
  }

  selectSuggestion = (item) => {
    this.setState({ search: item });
  }

  toggleMenu = (ev) => {
    this.setState({ showMenu: !this.state.showMenu });
  }

  showMenu = (ev) => {
    // if (this.timer) {
    //   clearTimeout(this.timer)
    // }
    this.setState({ showMenu: true });
  }

  closeMenu = (ev) => {
    // this.timer = setTimeout(() => {
    // }, 100);
    this.setState({ showMenu: false });
  }

  // onKeyUp = (ev) => {
  //   if (ev.key === 'Enter') {
  //     console.log('go');
  //   }
  // }

  renderSuggestions = (value) => {
    const data = {
      new: 19,
      unengaged: 79,
      regulars: 2,
    };

    // const keywords = ['The Rolling Stones', 'Rollercoasters', 'Rollergirl', 'Henry Rollins', 'Sonny Rollings'];
    
    // const suggest = keywords.filter(item => item.toUpperCase()
    //   .indexOf(value.toUpperCase()) !== -1)
    //   .filter(item => item.toUpperCase() !== value.toUpperCase());

    const s = artists.filter(item => item.name.toUpperCase()
      .indexOf(value.toUpperCase()) !== -1)
      .filter(item => item.name.toUpperCase() !== value.toUpperCase());

    const getData = (item) => {
      const n = item.length;
      const u = (100-n)-n/2;
      const r = 100 - n - u;
      return {n, u, r}
    }

    return s.slice(0,10).map((item, i) => 
      <Link to={`/segmenting/${item.name}`} className="as__result" 
        onClick={() => this.selectSuggestion(item.name)} key={i}>
        <div className="as__artist">
          {item.name}
          <img className="as__img" src={item.img} alt={item.name}/>
        </div>
        <div className="ai">
          <div className="ai__data ai__new">
            New {getData(item.name).n}%
          </div>
          <div className="ai__data ai__unengaged">
            Unengaged {getData(item.name).u}%
          </div>
          <div className="ai__data ai__regulars">
            Regulars {getData(item.name).r}%
          </div>
          {/* <div className="ai__data ai__regulars">
            {(item.length * 718543).toLocaleString()} people
          </div> */}
        </div>
      </Link>
    )
  }
  
  render() {
    const menu = this.state.search && this.state.showMenu ? 'menu menu--show' : 'menu';

    const data = {
      new: 19,
      unengaged: 79,
      regulars: 2,
    }

    return (
      <div className={menu} onBlur={this.closeMenu} tabIndex="0">
        <input type="text" className="as__input"
          name="search"
          placeholder="Search for fans who like..."
          value={this.state.search}
          onChange={this.handleChange}
          onFocus={this.toggleMenu} />
        <div className="menu__content as__results" onClick={this.closeMenu}>
          {this.state.search &&
            <Link to={`/segmenting/${this.state.search}`} className="as__result">
              {this.state.search}
              <div className="ai">
                <div className="ai__data ai__new">New {data.new}%</div>
                <div className="ai__data ai__unengaged">Unengaged {data.unengaged}%</div>
                <div className="ai__data ai__regulars">Regulars {data.regulars}%</div>
                {/* <div className="ai__data ai__peoples">Total {getRandomInt(0, 21581)} / 21581</div> */}
              </div>
            </Link>
          }
          { this.renderSuggestions(this.state.search) }
        </div>
      </div>
    )
  }
}

export default AS;


// WEBPACK FOOTER //
// ./src/components/AS.js